module.exports = __webpack_public_path__ + "img/customer.1b570433.png";